import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ConfigProvider} from "antd";
import zhCN from "antd/locale/zh_CN";
import "dayjs/locale/zh-cn";
import AutoScorllTop from "./AutoScorllTop";
import "./index.scss";
import {BrowserRouter} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ConfigProvider
        locale={zhCN}
        theme={{token: {colorPrimary: "#FF003C"}}}
    >
        <BrowserRouter>
            <AutoScorllTop>
                <App/>
            </AutoScorllTop>
        </BrowserRouter>
    </ConfigProvider>
);

reportWebVitals();